/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const SSHTargetAuthSshTargetIamRoleAuthKindEnum = {
    IamRole: 'IamRole'
};
/**
 * Check if a given object implements the SSHTargetAuthSshTargetIamRoleAuth interface.
 */
export function instanceOfSSHTargetAuthSshTargetIamRoleAuth(value) {
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
export function SSHTargetAuthSshTargetIamRoleAuthFromJSON(json) {
    return SSHTargetAuthSshTargetIamRoleAuthFromJSONTyped(json, false);
}
export function SSHTargetAuthSshTargetIamRoleAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'kind': json['kind'],
    };
}
export function SSHTargetAuthSshTargetIamRoleAuthToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'kind': value['kind'],
    };
}
